export class PackingDto {
  guid: string;
  qty_balance: number;
  increasing_awaiting_balance: boolean;
}